import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { AppStateContext } from "@/components/context/AppContext";

// Bare `/dashboard` is referenced in several places (PaymentPopup,
// pricingPlans, etc.) — it's the natural "land somewhere appropriate"
// destination. This component picks the right per-role landing page
// based on the loaded profile, then replaces the history entry so the
// user can't back into /dashboard and bounce again.
export default function DashboardRedirect() {
  const { userProfile } = useContext(AppStateContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userProfile) return;
    // A candidate has no dashboard: their interviews are on /my-interviews.
    const target =
      userProfile.role === "hr"
        ? "/dashboard/agency"
        : "/my-interviews";
    navigate(target, { replace: true });
  }, [userProfile, navigate]);

  return null;
}
